// TK instead of PK for PreKindergarten is intentional
const { ALL_PA_GRADES } = require('./pear')

const GRADES_LIST = [
  {
    label: 'All',
    value: 'All',
  },
  ...ALL_PA_GRADES.map(({ code, description }) => ({
    label: description,
    value: code,
  })),
]

module.exports = {
  GRADES_LIST,
}
